module.exports = __webpack_public_path__ + "static/media/icon-retry.8a91565a.svg";